import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

type Props = {
    title: string,
    subtitle?: string,
    buttons?: ReactNode
}

const UXPageHeader = ({ title, subtitle, buttons }: Props) => {
    return (
        <Box>
            <Typography sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }} variant='h5'>
                {title}
                <Box sx={{ width: 'auto', flexShrink: 0 }}>
                    {buttons || null}
                </Box>                
            </Typography>
            <Typography variant='body2'>
                {subtitle || null}
            </Typography>
        </Box>
    )
}

export default UXPageHeader;